import { FC } from 'react';

import { CountChips } from '../../../../../components/CountChip';

import { DspAudience as DspAudienceSource, DspAudienceSourceCategoryGroup } from '../../../../../types/DspAudience';
import DspAudienceSourceUtils from '../../../../../utils/DspAudienceSourceUtils';

interface CampaignAdGroupAudienceTargetingChipsProps {
    items: DspAudienceSource[];
}

const CampaignAdGroupAudienceTargetingChips: FC<CampaignAdGroupAudienceTargetingChipsProps> = ({ items }) => {
    const groups: DspAudienceSourceCategoryGroup[] = DspAudienceSourceUtils.toDspAudienceSourceCategoryGroups(items);

    return (
        <CountChips
            items={groups.map((group: DspAudienceSourceCategoryGroup) => {
                return {
                    label: group.category,
                    count: group.audienceSources.length,
                };
            })}
        />
    );
};

export default CampaignAdGroupAudienceTargetingChips;
